"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metrics = void 0;

var _currentScopes = require("../currentScopes.js");

var _debugBuild = require("../debug-build.js");

require("../tracing/errors.js");

var _worldwide = require("../utils-hoist/worldwide.js");

require("../utils-hoist/debug-build.js");

var _logger = require("../utils-hoist/logger.js");

var _time = require("../utils-hoist/time.js");

var _spanUtils = require("../utils/spanUtils.js");

var _trace = require("../tracing/trace.js");

var _handleCallbackErrors = require("../utils/handleCallbackErrors.js");

var _constants = require("./constants.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Gets the metrics aggregator for a given client.
 * @param client The client for which to get the metrics aggregator.
 * @param Aggregator Optional metrics aggregator class to use to create an aggregator if one does not exist.
 */
function getMetricsAggregatorForClient(client, Aggregator) {
  const globalMetricsAggregators = (0, _worldwide.getGlobalSingleton)('globalMetricsAggregators', () => new WeakMap());
  const aggregator = globalMetricsAggregators.get(client);

  if (aggregator) {
    return aggregator;
  }

  const newAggregator = new Aggregator(client);
  client.on('flush', () => newAggregator.flush());
  client.on('close', () => newAggregator.close());
  globalMetricsAggregators.set(client, newAggregator);
  return newAggregator;
}

function addToMetricsAggregator(Aggregator, metricType, name, value, data = {}) {
  const client = data.client || (0, _currentScopes.getClient)();

  if (!client) {
    return;
  }

  const span = (0, _spanUtils.getActiveSpan)();
  const rootSpan = span ? (0, _spanUtils.getRootSpan)(span) : undefined;
  const transactionName = rootSpan && (0, _spanUtils.spanToJSON)(rootSpan).description;
  const unit = data.unit,
        tags = data.tags,
        timestamp = data.timestamp;

  const _client$getOptions = client.getOptions(),
        release = _client$getOptions.release,
        environment = _client$getOptions.environment;

  const metricTags = {};

  if (release) {
    metricTags.release = release;
  }

  if (environment) {
    metricTags.environment = environment;
  }

  if (transactionName) {
    metricTags.transaction = transactionName;
  }

  _debugBuild.DEBUG_BUILD && _logger.logger.log(`Adding value of ${value} to ${metricType} metric ${name}`);
  const aggregator = getMetricsAggregatorForClient(client, Aggregator);
  aggregator.add(metricType, name, value, unit, _objectSpread(_objectSpread({}, metricTags), tags), timestamp);
}
/**
 * Adds a value to a counter metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function increment(aggregator, name, value = 1, data) {
  addToMetricsAggregator(aggregator, _constants.COUNTER_METRIC_TYPE, name, ensureNumber(value), data);
}
/**
 * Adds a value to a distribution metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function distribution(aggregator, name, value, data) {
  addToMetricsAggregator(aggregator, _constants.DISTRIBUTION_METRIC_TYPE, name, ensureNumber(value), data);
}
/**
 * Adds a timing metric.
 * The metric is added as a distribution metric.
 *
 * You can either directly capture a numeric `value`, or wrap a callback function in `timing`.
 * In the latter case, the duration of the callback execution will be captured as a span & a metric.
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function timing(aggregator, name, value, unit = 'second', data) {
  // callback form
  if (typeof value === 'function') {
    const startTime = (0, _time.timestampInSeconds)();
    return (0, _trace.startSpanManual)({
      op: 'metrics.timing',
      name,
      startTime,
      onlyIfParent: true
    }, span => {
      return (0, _handleCallbackErrors.handleCallbackErrors)(() => value(), () => {// no special error handling necessary
      }, () => {
        const endTime = (0, _time.timestampInSeconds)();
        const timeDiff = endTime - startTime; // eslint-disable-next-line deprecation/deprecation

        distribution(aggregator, name, timeDiff, _objectSpread(_objectSpread({}, data), {}, {
          unit: 'second'
        }));
        span.end(endTime);
      });
    });
  } // value form
  // eslint-disable-next-line deprecation/deprecation


  distribution(aggregator, name, value, _objectSpread(_objectSpread({}, data), {}, {
    unit
  }));
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function set(aggregator, name, value, data) {
  addToMetricsAggregator(aggregator, _constants.SET_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @deprecated The Sentry metrics beta has ended. This method will be removed in a future release.
 */


function gauge(aggregator, name, value, data) {
  addToMetricsAggregator(aggregator, _constants.GAUGE_METRIC_TYPE, name, ensureNumber(value), data);
}
/**
 * The metrics API is used to capture custom metrics in Sentry.
 *
 * @deprecated The Sentry metrics beta has ended. This export will be removed in a future release.
 */


const metrics = exports.metrics = {
  increment,
  distribution,
  set,
  gauge,
  timing,

  /**
   * @ignore This is for internal use only.
   */
  getMetricsAggregatorForClient
}; // Although this is typed to be a number, we try to handle strings as well here

function ensureNumber(number) {
  return typeof number === 'string' ? parseInt(number) : number;
}